module.exports = __webpack_public_path__ + "img/chr_ts_90_21_6.38ed02eb.png";